import { QThemeProvider, QContainer, AnalysisRequestSubmissionComplete } from '@kw/quokka-ui';
import { styled } from '@mui/material/styles';
import { useContext } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { BackgroundProgressBar } from '../../BackgroundProgressBar/BackgroundProgressBar';
import BackButton from '../../shared/BackButton';
import { RequestAnalysisInfoContext } from './RequestAnalysisInfoContext';
import { APPLICATIONS_ALL_STATUSES_PATH } from './requestAnalysisNavigation';

export default function SubmissionQueueConfirmation() {
  const { numberOfSubmissions, submittedAt } = useContext(RequestAnalysisInfoContext);
  const navigate = useNavigate();

  // submittedAt is only set once a submission succeeds, so its absence means the page was opened directly or reloaded
  if (!submittedAt) {
    return <Navigate to="/request-analysis" replace />;
  }

  return (
    <QThemeProvider>
      <QContainer
        sx={{
          paddingTop: '16px',
          paddingBottom: '0px',
          maxWidth: '100% !important',
          display: 'flex',
          flexDirection: 'column',
          rowGap: 2,
          overflow: 'auto',
        }}
      >
        <BackgroundProgressBar />
        <BackButton href="/request-analysis" text="Back to Request Analysis" />
        <SubmissionWrapper>
          <AnalysisRequestSubmissionComplete
            numberOfSubmissions={numberOfSubmissions}
            submittedAt={submittedAt}
            onReturnToRequestAnalysis={() => navigate('/request-analysis')}
            onGoToApplicationsList={() => navigate(APPLICATIONS_ALL_STATUSES_PATH)}
          />
        </SubmissionWrapper>
      </QContainer>
    </QThemeProvider>
  );
}

const SubmissionWrapper = styled('div')`
  width: 100%;
  margin: 20px auto 0;
`;
